import React from 'react';
import Phone from '../../images/phone1.svg';
import Pin from '../../images/PIN.svg';
import NotFound from '../../images/not-found.png';
import { Link } from 'react-router-dom';
import { BASE_URL } from 'utils/constants';
import parse from 'html-react-parser';

const Company = ({ company }) => {
  return (
    <div className="company-box pb-3 news d-flex text-left">
      <Link to={'/companies/' + company.id}>
        <div className="company-image-container">
          <img
            className="company-image"
            src={
              company.images ? `${BASE_URL}/${company.images.url}` : NotFound
            }
            alt="company"
          />
        </div>
      </Link>
      <div className="company-info">
        <Link to={'/companies/' + company.id}>
          <h5 className="company-name mb-2">{company.name}</h5>
          <div className="d-flex">
            <img src={Pin} alt="pin" />
            <p className="ml-2 small-text">
              {' '}
              {company.address}, {company.town}
            </p>
          </div>
          <div className="d-flex justify-content-between">
            {company.phone ? (
              <div className="d-flex">
                <img src={Phone} alt="phone"></img>

                <p className="ml-2 small-text">{company.phone}</p>
              </div>
            ) : (
              <div className="d-flex">
                <img src={Phone} alt="phone"></img>

                <p className="ml-2 small-text">{company.mobile}</p>
              </div>
            )}
          </div>
        </Link>
        {company.description && (
          <p className="news-info-text">
            {company.description &&
              parse(company.description.substring(0, 200))}
            ...
          </p>
        )}
      </div>
    </div>
  );
};

export default Company;
